import { GuidedSearchTileComponent } from './guided-search-tile.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatIconModule } from '@angular/material/icon';
import { EventPreventDefaultModule } from '@zelis/platform-ui-components';
import { Ng2FittextModule } from 'ng2-fittext';
import { PendoModule } from '@directives/pendo/pendo.module';
import { DlsCardModule } from '@zelis/dls/card';

@NgModule({
  declarations: [GuidedSearchTileComponent],
  imports: [
    CommonModule,
    TranslateModule,
    FlexLayoutModule,
    DlsCardModule,
    MatIconModule,
    EventPreventDefaultModule,
    Ng2FittextModule,
    PendoModule,
  ],
  exports: [GuidedSearchTileComponent],
})
export class GuidedSearchTileModule {}
